module.exports = __webpack_public_path__ + "img/IMG-20200910-WA0000.cefad6c6.jpg";